var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F0F2F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F8F8FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9228 21.4529C22.9645 21.4529 22.1012 21.8667 21.502 22.525L16.1124 19.187C16.2563 18.8186 16.3361 18.4185 16.3361 18C16.3361 17.5813 16.2563 17.1812 16.1124 16.813L21.502 13.4748C22.1012 14.1331 22.9645 14.5471 23.9228 14.5471C25.7279 14.5471 27.1964 13.0786 27.1964 11.2735C27.1964 9.46835 25.7279 8 23.9228 8C22.1177 8 20.6492 9.4685 20.6492 11.2736C20.6492 11.6922 20.7291 12.0922 20.8729 12.4606L15.4835 15.7986C14.8843 15.1403 14.0209 14.7264 13.0627 14.7264C11.2576 14.7264 9.78906 16.195 9.78906 18C9.78906 19.8051 11.2576 21.2736 13.0627 21.2736C14.0209 21.2736 14.8843 20.8598 15.4835 20.2014L20.8729 23.5394C20.7291 23.9077 20.6492 24.3078 20.6492 24.7265C20.6492 26.5315 22.1177 28 23.9228 28C25.7279 28 27.1964 26.5315 27.1964 24.7265C27.1964 22.9214 25.7279 21.4529 23.9228 21.4529ZM21.8429 11.2736C21.8429 10.1268 22.7759 9.19369 23.9228 9.19369C25.0696 9.19369 26.0027 10.1268 26.0027 11.2736C26.0027 12.4205 25.0696 13.3535 23.9228 13.3535C22.7759 13.3535 21.8429 12.4205 21.8429 11.2736ZM13.0627 20.0799C11.9157 20.0799 10.9826 19.1468 10.9826 18C10.9826 16.8531 11.9157 15.9201 13.0627 15.9201C14.2095 15.9201 15.1424 16.8531 15.1424 18C15.1424 19.1468 14.2095 20.0799 13.0627 20.0799ZM21.8429 24.7263C21.8429 23.5795 22.7759 22.6464 23.9228 22.6464C25.0696 22.6464 26.0027 23.5795 26.0027 24.7263C26.0027 25.8732 25.0696 26.8063 23.9228 26.8063C22.7759 26.8063 21.8429 25.8732 21.8429 24.7263Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.bf9d6ed7244d81d9d1e65459734108f3.svg";
export { ForwardRef as ReactComponent };